import { usePathname, useRouter } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';
import { Platform, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { isDesktop } from '@/core';
import { Card, Text } from '@/ui';
import { Info } from '@/ui/icons';
import { ChevronRight } from '@/ui/icons/chevron-right';
import { MenuItem } from '@/ui/menu-item';

import { NavigationButton, NavigationButtonTypes } from '../navigation-button';

export default function Legal() {
  const { styles, theme } = useStyles(stylesheet);
  const pathname = usePathname();
  const router = useRouter();

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: theme.colors.background_1,
        alignItems: 'center',
      }}
    >
      <View style={styles.container}>
        {isDesktop() ? (
          <View style={{ gap: 16 }}>
            <NavigationButton
              type={NavigationButtonTypes.back_with_text}
              onPress={() => {
                if (pathname.includes('partner')) {
                  router.navigate('/partner/more');
                } else {
                  router.navigate('/account');
                }
              }}
            />

            <Text type="largeTitle">Support</Text>
          </View>
        ) : null}

        <Text tx="legal.policies" type="title1" />

        <Card>
          <MenuItem
            leftIcon={<Info />}
            leftIconFillColor={theme.colors.icon.color}
            rightIcon={<ChevronRight />}
            rightIconFillColor={theme.colors.icon.color}
            tx="legal.privacyPolicy"
            onPress={async () => {
              if (Platform.OS === 'web') {
                window.open(
                  'https://www.eonrides.com/legal/terms-privacy-policy',
                  '_blank'
                );
              } else {
                await WebBrowser.openBrowserAsync(
                  'https://www.eonrides.com/legal/terms-privacy-policy'
                );
              }
            }}
            style={{ width: '100%' }}
          />
        </Card>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    paddingTop: 24,
    paddingLeft: 16,
    paddingRight: 16,
    gap: 16,
    backgroundColor: theme.colors.background_1,
    maxWidth: {
      xs: '100%',
      sm: 600,
      md: 800,
    },
    width: {
      xs: '100%',
      md: 600,
    },
  },
}));
